/**
 * Notification utility using react-hot-toast
 * Replaces Notiflix notifications throughout the app
 */
import { toast } from "react-hot-toast";

const notify = {
    success: (message) => {
        toast.success(message, {
            duration: 4000,
        });
    },

    failure: (message) => {
        toast.error(message, {
            duration: 4000,
        });
    },

    warning: (message) => {
        toast(message, {
            icon: "⚠️",
            duration: 4000,
            style: {
                background: "#f59e0b",
                color: "#ffffff",
            },
        });
    },

    info: (message) => {
        toast(message, {
            icon: "ℹ️",
            duration: 4000,
            style: {
                background: "#3b82f6",
                color: "#ffffff",
            },
        });
    },
};

export default notify;
